// extracted by mini-css-extract-plugin
export default {"card":"dyV4UF8AFs","cardContent":"FaBuBPOZki"};